<banner-app [Fixtop]="''" [retroSelected]="false" [infoDueno]="true" [showPromo]="true"></banner-app>

<div class="final-page__container">
  <div class="final-page__image-container">
    <img src="./assets/img/moto-fasecolda.png" class="final-page__image" alt="Moto nueva - Información Fasecolda"
      loading="lazy" />
  </div>

  <div class="final-page__text-container">
    <p class="final-page__text-title">No pudimos validar la información de tu placa en Fasecolda.</p>
    <p class="final-page__text">
      Para continuar un asesor te contactará en las próximas horas.
    </p>
    <!-- <p class="final-page__text">No te preocupes, esto es temporal.</p>
    <p class="final-page__text">
      <strong>Vuelve a intentarlo en un par de días</strong> o te
      contactaremos cuando puedas continuar con el proceso.
    </p> -->
  </div>

  <div class="final-page__button-container">
    <button class="final-page__button" (click)="goToSura()">
      Volver a sura.co
    </button>
  </div>
</div>

<app-footer-app class="footer-fixed" />